import TempoAPI from './TempoAPI'

export default class ConfigAPI extends TempoAPI {
    constructor() {
        super();
        this.serviceName = 'get_config';
    }
    
    getConfig(handler) {
        const data = {};
        this.makeAPICall(this.serviceName, data, handler);
    }
}